var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    viewBox: "0 0 60 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 34.3236H0C0.960157 24.1538 6.77335 15.4667 15.356 10.8161L10.3788 2.19431C10.098 1.71096 10.2613 1.09698 10.7446 0.816122C11.228 0.53526 11.8419 0.698552 12.1228 1.1819L17.1653 9.91475C21.0124 8.15773 25.3429 7.17798 30 7.17798C34.6571 7.17798 38.9876 8.15773 42.8348 9.91475L47.8772 1.1819C48.1515 0.698552 48.772 0.53526 49.2489 0.816122C49.7257 1.09698 49.8955 1.71096 49.6146 2.19431L44.6375 10.8161C53.2267 15.4667 59.0398 24.1538 60 34.3236ZM43.7688 25.8978C45.16 25.8978 46.29 24.7678 46.2835 23.3831C46.2835 21.9984 45.16 20.8684 43.7688 20.8684C42.3841 20.8684 41.2541 21.9918 41.2541 23.3831C41.2541 24.7678 42.3775 25.8978 43.7688 25.8978ZM16.2247 25.8978C17.6159 25.8978 18.7459 24.7678 18.7394 23.3831C18.7394 21.9984 17.6159 20.8684 16.2247 20.8684C14.84 20.8684 13.71 21.9918 13.71 23.3831C13.71 24.7678 14.8334 25.8978 16.2247 25.8978Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidTv);
export default __webpack_public_path__ + "static/media/AndroidTv.4bce9ea71569105161c1dcd3bcd87202.svg";
export { ForwardRef as ReactComponent };